
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/energy-solutions",
      function () {
        return require("private-next-pages/energy-solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/energy-solutions"])
      });
    }
  